import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchConnectedAccounts = ({ offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'users/me/linked_accounts',
        params: {
            offset,
            limit
        }
    }, true)
    .then(response => response.data)
    .catch(handleServerError);
}

export const createConnectedAccount = ({ email, password, currentPassword }) => {
    return AjaxService({
        method: 'post',
        url: 'users/me/linked_accounts',
        data: {
            password: currentPassword,
            account_email: email,
            account_password: password
        }
    }, true)
    .then(response => ({
        ...response.data,
        id: response.data?.account_id,
        name: response.data?.account_name
    }))
    .catch(handleServerError);
}

export const removeConnectedAccount = ({ email, password }) => {
    return AjaxService({
        method: 'delete',
        url: `users/me/linked_accounts`,
        data: {
            account_email: email,
            password
        }
    }, true)
    .then(response => response.data)
    .catch(handleServerError);
}
